import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { Language } from '../../../configs/language';
import { LoadState } from '../../../pages/store/types';
import clientSvc from '../../../services/client/clientSvc';
import { BalanceResponse, IBalance } from '../../../services/client/types';
import { camelCaseMapData } from '../../../utils/formater';

type BalanceState = LoadState<IBalance>;

export const initialState: BalanceState = {
  error: '',
  loading: false,
  data: null,
};

const fetchBalance = createAsyncThunk(
  'fetchBalance',
  async (language: Language) => clientSvc.getBalance(language)
);

export const balanceSlice = createSlice({
  name: 'balance',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchBalance.pending, (state) => {
      state.loading = true;
      state.error = '';
      state.data = null;
    });
    builder.addCase(fetchBalance.fulfilled, (state, { payload: balance }) => {
      state.loading = false;
      state.data = camelCaseMapData<BalanceResponse, IBalance>(balance);
      state.error = '';
    });

    builder.addCase(fetchBalance.rejected, (state) => {
      state.loading = false;
      state.data = null;
      state.error = 'ERROR';
    });
  },
});

export { fetchBalance };
export default balanceSlice.reducer;
